import type { IncotermsConfig } from '../../../domain/types/configs/company/IncotermsConfig';

export const incotermsConfig: IncotermsConfig = {
  incoterms: [
    {
      value: "EXW",
      label: "Ex Works",
      visible: true
    },
    {
      value: "FCA",
      label: "Free Carrier",
      visible: true
    },
    {
      label: "Carriage Paid To",
      value: "CPT",
      visible: true
    },
    {
      value: "CFR",
      label: "Cost and Freight",
      visible: true
    },
    {
      value: "CIP",
      label: "Carriage and Insurance Paid To",
      visible: true
    },
    {
      value: "CIF",
      label: "Cost, Insurance and Freight",
      visible: true
    },
    {
      label: "Delivered at Frontier",
      value: "DAF",
      visible: true
    },
    {
      label: "Delivered At Terminal",
      value: "DAT",
      visible: true
    },
    {
      label: "Delivered At Place",
      value: "DAP",
      visible: true
    },
    {
      value: "DDP",
      label: "Delivered Duty Paid",
      visible: true
    },
    {
      value: "DDU ",
      label: "Delivered Duty Unpaid",
      visible: true
    },
    {
      value: "DPU",
      label: "Delivered At Place Unloaded ",
      visible: true
    },
    {
      label: "Delivered ex Ship",
      value: "DES",
      visible: true
    },
    {
      label: "Delivery ex Quay",
      value: "DEQ",
      visible: true
    },
    {
      label: "FAS Free Alongside Ship",
      value: "FAS",
      visible: true
    },
    {
      value: "FOB",
      label: "FOB Free On Board",
      visible: true
    }
  ]
}; 